import React, { useEffect, useMemo, useState } from "react";
import {
  Acma_senderidimplementation_statuscode,
  IFirewallImplementation,
  IMNO,
} from "../../api";
import { Label, TextArea, TextInput } from "acma-spa";

export interface ImplementationDetailsProps {
  implementers: IMNO[];
  implementations: IFirewallImplementation[];
}

export const ImplementationDetails: React.FC<ImplementationDetailsProps> = (
  props
) => {
  const comments = props.implementations.filter(
    (r) => r.status == Acma_senderidimplementation_statuscode.Declined
  ).sort((a,b) => (a.date?.getTime() || 0) - (b.date?.getTime() || 0))

  const getStatus = (id?: string) => {
    var implementation = props.implementations.filter(
      (r) => r.implementerId == id
    )[0];
    if (implementation) {
      if (implementation.status == Acma_senderidimplementation_statuscode.Added)
        return "Completed";
      else if (
        implementation.status == Acma_senderidimplementation_statuscode.Declined
      )
        return "Declined";
      else return "Pending";
    } else {
      return "Pending";
    }
  };

  return (
    <div className="row">
      {props.implementers.map((r) => (
        <div className="col-6 mb-2">
          <Label id={r.value ?? ""} label={r.label ?? ""}>
            <TextInput
              value={getStatus(r.value)}
              onChange={(v) => {}}
              readonly={true}
            />
          </Label>
        </div>
      ))}
      { comments?.length > 0 &&
        <div className="col-6 mb-2">
          <Label id={"reason"} label={"Declined reason"}>
            <TextArea
              value={
                comments
                  .map(
                    (i) =>
                      `${i.date?.toLocaleDateString() ?? new Date().toLocaleDateString()} - ${
                        props.implementers.filter(
                          (j) => j.value == i.implementerId
                        )[0]?.label
                      }: ${i?.comments || ""}`
                  )
                  .join("\n") || ""
              }
              onChange={(v) => {}}
              readonly={true}
            />
          </Label>
        </div>
      }
    </div>
  );
};
